export enum TripPatternOrientation {
    OUTBOUND = 1, //Viaje de Ida
    INBOUND = 2, // Viaje de vuelta
    CIRCULAR = 3 // Viaje circular
}